import Axios from 'axios'

const actions = {
  async submitForm (context) {
    try {
      const response = await Axios.post(context.state.apiUrl, context.state.userData)
      console.log(response.data.msg)
      if (response.data.msg === 'ERROR') {
        return response.data.content
      }
      return null
    } catch (error) {
      console.log(error)
      // alert(error)
    }
  }
}

export default actions
